module.exports = __webpack_public_path__ + "img/photo-2.8bd249d5.png";